export const enum CONFIG_ANIM_TIME {
  SHORT = 200,
  MEDIUM = 400,
  LONG = 500,
  ONE_SECOND = 1000,
  TWO_SECONDS = 2000,
  THREE_SECONDS = 3000,
  HALF_MINUTE = 30000,
}

export const HOME_PAGE_DYNAMIC_CONTENT_KEY = {
  MENDEN: 'menden',
  HAMM: 'hamm',
  ISERLOHN: 'iserlohn',
  ARNSBERG: 'arnsberg',
  LUENEN: 'luenen',
  SOEST: 'soest',
};

export const scriptSchemaHamm = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Was kostet ein Immobilienmakler in Hamm?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Maklerprovision ist in Deutschland gesetzlich geregelt und wird in der Regel zwischen Käufer und Verkäufer aufgeteilt. Die Provision kann je nach individueller Vereinbarung variieren. Bei einer Vermietung ist die Provision vom Vermieter zu tragen, da das Bestellerprinzip gilt. Die Kosten lohnen sich jedoch, da ein Makler den bestmöglichen Preis erzielt und den gesamten Prozess professionell begleitet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Warum sollte ich einen Makler beauftragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein erfahrener Immobilienmakler übernimmt alle wichtigen Schritte im Verkaufs- oder Vermietungsprozess. Dazu gehören die marktgerechte Wertermittlung, eine professionelle Vermarktungsstrategie, die Organisation von Besichtigungen und die rechtssichere Vertragsabwicklung. Durch die Expertise eines Maklers erzielen Verkäufer oft einen höheren Verkaufspreis, vermeiden rechtliche Fallstricke und sparen wertvolle Zeit.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie lange dauert es, eine Immobilie in Hamm zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Dauer eines Immobilienverkaufs hängt von verschiedenen Faktoren wie Lage, Preisgestaltung und Marktnachfrage ab. In begehrten Lagen kann ein Verkauf bereits innerhalb weniger Wochen abgeschlossen sein. Durch eine zielgerichtete Vermarktung, die Nutzung professioneller Netzwerke und eine realistische Preisbewertung kann ein Makler den Verkaufsprozess erheblich beschleunigen.',
      },
    },
  ],
};

export const scriptSchemaIserlohn = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie läuft der Verkaufsprozess mit einem Immobilienmakler ab?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein Immobilienmakler begleitet Sie durch alle Phasen des Verkaufs. Zunächst wird eine professionelle Wertermittlung durchgeführt, gefolgt von der Vermarktung auf relevanten Plattformen. Nach der Koordination von Besichtigungsterminen übernimmt der Makler die Preisverhandlungen und begleitet Sie bis zum notariellen Vertragsabschluss. So stellen Sie sicher, dass Sie einen optimalen Verkaufspreis erzielen und der gesamte Prozess effizient und rechtssicher abläuft.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Unterlagen werden für den Immobilienverkauf benötigt?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Für einen reibungslosen Verkauf sollten wichtige Dokumente bereitliegen, darunter der Grundbuchauszug, ein aktueller Energieausweis, Baupläne sowie Nachweise über Modernisierungen. Ein Immobilienmakler hilft Ihnen, alle erforderlichen Unterlagen zu beschaffen. Fehlende Dokumente können den Verkaufsprozess verzögern – mit professioneller Unterstützung sind Sie bestens vorbereitet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Kann ich meine Immobilie auch ohne Makler verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja, ein Verkauf ohne Makler ist möglich, jedoch oft mit mehr Aufwand und Risiken verbunden. Ein Makler übernimmt nicht nur die Wertermittlung und Vermarktung, sondern sorgt auch für rechtssichere Verträge und einen reibungslosen Ablauf, um Fehler und finanzielle Einbußen zu vermeiden. Gerade in einem dynamischen Markt kann eine falsche Preisstrategie zu längeren Verkaufszeiten oder einem niedrigeren Erlös führen.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wann ist der beste Zeitpunkt, eine Immobilie in Iserlohn zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der ideale Verkaufszeitpunkt hängt von Marktentwicklung, Nachfrage und Zinssituation ab. Ein Immobilienmakler kann Sie beraten, wann Ihre Immobilie den besten Preis erzielt und ob sich ein Verkauf aktuell lohnt. Markttrends ändern sich regelmäßig – eine professionelle Einschätzung hilft, den richtigen Moment für den Verkauf nicht zu verpassen.',
      },
    },
  ],
};

export const scriptSchemaArnsberg = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Was kostet ein Immobilienmakler in Arnsberg beim Verkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Kosten für einen Immobilienmakler richten sich nach verschiedenen Faktoren – etwa dem Umfang der Leistungen, der Art der Immobilie und der individuellen Vereinbarung zwischen Verkäufer und Makler. In vielen Fällen wird die Maklerprovision beim Verkauf zwischen Käufer und Verkäufer aufgeteilt. Bei Beckschulte Immobilien-Management erhalten Sie eine transparente und faire Kostenübersicht – natürlich vorab und ohne versteckte Gebühren. Sprechen Sie uns einfach an, wir beraten Sie gerne unverbindlich.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Vorteile bietet ein Immobilienmakler in Arnsberg gegenüber dem Privatverkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein qualifizierter Immobilienmakler kennt den lokalen Markt in Arnsberg genau, ermittelt den realistischen Verkaufspreis, erstellt ein professionelles Exposé, übernimmt Besichtigungen und führt Verhandlungen. So sparen Sie Zeit, vermeiden rechtliche Risiken und erzielen in der Regel einen besseren Preis. Mit Beckschulte Immobilien profitieren Sie zusätzlich von persönlicher Betreuung und langjähriger Erfahrung im Sauerland.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie schnell lässt sich eine Immobilie in Arnsberg verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Vermarktungsdauer hängt von Lage, Zustand und Preisgestaltung ab. In gefragten Arnsberger Stadtteilen wie Neheim, Bruchhausen oder Hüsten kann ein Verkauf oft innerhalb weniger Wochen erfolgen. Eine realistische Bewertung, zielgruppengerechte Präsentation und strukturierte Vermarktung beschleunigen den Prozess deutlich – dafür sorgen wir mit Erfahrung und System.',
      },
    },
  ],
};

export const scriptSchemaLuenen = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Welche Vorteile hat es, einen lokalen Makler in Lünen zu beauftragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ein ortskundiger Makler kennt nicht nur aktuelle Immobilienpreise, sondern auch die kleinen Unterschiede zwischen Stadtteilen wie Gahmen, Wethmar oder Lünen-Süd. Er kann realistisch einschätzen, wie sich Lage, Infrastruktur und Nachbarschaft auf den Verkauf oder die Vermietung auswirken. Zudem profitieren Sie von kurzen Wegen, persönlicher Erreichbarkeit und einer Vermarktung, die auf die lokalen Gegebenheiten abgestimmt ist.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wann ist der beste Zeitpunkt, um in Lünen eine Immobilie zu verkaufen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Der optimale Verkaufszeitpunkt hängt von verschiedenen Faktoren ab – z. B. Zinssituation, Marktnachfrage und Saisonverlauf. In Lünen beobachten wir eine konstant solide Nachfrage, insbesondere bei Einfamilienhäusern und gut angebundenen Wohnungen. Eine fundierte Marktanalyse hilft, die richtige Entscheidung zu treffen. Wir beraten Sie ehrlich und individuell, wann ein Verkauf für Sie sinnvoll ist.',
      },
    },
    {
      '@type': 'Question',
      name: 'Wie läuft eine Immobilienbewertung in Lünen ab?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Zunächst besichtigen wir Ihre Immobilie vor Ort und analysieren Lage, Zustand, Ausstattung und Vergleichswerte im Umfeld. Dazu nutzen wir aktuelle Daten zu Bodenrichtwerten und realen Verkaufspreisen in Lünen. Das Ergebnis ist eine realistische und nachvollziehbare Einschätzung – als Grundlage für Vermarktung oder Entscheidungsfindung.',
      },
    },
  ],
};

export const scriptSchemaSoest = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Wie finde ich den passenden Makler für meine Immobilie in Soest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Achten Sie bei der Maklerwahl in Soest nicht nur auf schöne Versprechen, sondern auf Erfahrung, regionale Marktkenntnis und transparente Kommunikation. Ein guter Immobilienmakler nimmt sich Zeit für Ihre Fragen, kennt die lokalen Besonderheiten – etwa im Bereich Denkmalschutz in der Altstadt oder Neubaugebiete in Soest-Ost – und arbeitet strukturiert. Bei Beckschulte Immobilien setzen wir auf persönliche Beratung, nachvollziehbare Prozesse und messbare Ergebnisse.',
      },
    },
    {
      '@type': 'Question',
      name: 'Was muss ich beim Hausverkauf in Soest beachten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Jede Stadt hat ihre Eigenheiten – auch Soest. Beim Hausverkauf spielen Faktoren wie der Bodenrichtwert, die Energieeffizienz des Gebäudes, rechtliche Vorgaben und der optimale Zeitpunkt eine große Rolle. Insbesondere in historisch geprägten Vierteln oder bei ländlichen Lagen im Umland ist eine fachkundige Bewertung entscheidend. Wir unterstützen Sie dabei, alle Rahmenbedingungen zu klären – damit der Verkauf reibungslos verläuft.',
      },
    },
    {
      '@type': 'Question',
      name: 'Welche Rolle spielt die Lage innerhalb von Soest beim Immobilienverkauf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Die Lage ist ein entscheidender Faktor für den Immobilienwert – auch in Soest. Ob Altstadt mit Fachwerkcharme, die Nähe zum Bahnhof, gute Anbindung an die B1 oder ruhige Wohnlagen in Soest-Bergede: Jede Mikro-Lage spricht unterschiedliche Käufergruppen an. Wir analysieren genau, welches Potenzial Ihre Immobilie bietet und richten die Vermarktung gezielt darauf aus. So steigern wir die Erfolgschancen und sprechen genau die richtigen Interessenten an.',
      },
    },
  ],
};
